module.exports = require('./helpers/bundle-url').getBundleURL('fx0PE') + "logo-dark.eefe0b7f.svg";